

jQuery(function($) {

  var scheduledAnimationFrame;
  function readAndUpdatePage(){
    updateParallaxPosition();
    scheduledAnimationFrame = false;
  }

  function onScroll (evt) {
    // Store the scroll value for laterz.
    // lastScrollY = window.scrollY;

    // Prevent multiple rAF callbacks.
    if (scheduledAnimationFrame){
      return;
    }



    scheduledAnimationFrame = true;
    requestAnimationFrame(readAndUpdatePage);
  }

  function setElementShift($el) {
      const rectWrapper = $el.getBoundingClientRect();
      const rectInner = $('.parallax', $el)[0].getBoundingClientRect();
      const rect = $el.getBoundingClientRect();
      // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
      const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
      const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

      // check in viewport
      const vertInView = (rectInner.top <= windowHeight) && ((rectInner.top + rectInner.height) >= 0);
      // const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);
      if(!vertInView) return;

      // reference position (when rect.top - rect.height / 2 == windowHeight / 2)

      const currentCenterPosition = rectWrapper.top + rectInner.height / 2;
      const positionZero = windowHeight / 2;
      const normalizedPosition = positionZero - currentCenterPosition;
      const newParallaxShift = normalizedPosition*0.13;
      $('.parallax', $el).css('transform', 'translate3d(0, ' + (newParallaxShift) + 'px, 0 )')
  }

  function updateParallaxPosition() {
    $('.parallax-wrapper').each(function() {
      if(window.innerWidth > 767) {
       var $image = $(this)[0];
        setElementShift($image);
      } else {
        $('.parallax', this).css('transform', 'none');
      }
    })
  }


  $(document).ready(function() {

    $(window).on('scroll', function() {
      onScroll();
    })

  })
})
